// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__20Pc2","select":"Header_select__1nxTy","clinic":"Header_clinic__2HtNp"};